/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=75b5a082&lang=scss"
import "./index.vue?vue&type=style&index=1&id=75b5a082&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b5a082"]])

export default __exports__